import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { TextInput } from "./textInput";

const handleSearch = (searchFunction: (val: any) => void, query: any) => {
  searchFunction(query);
};

const handleDebouncedSearch = debounce(handleSearch, 800);

export const SearchInput = ({
  searchFunction,
  placeholder = "Search",
  className = "",
}: {
  searchFunction: (val: string) => void;
  placeholder?: string;
  className?: string;
}) => {
  const [searchParams, setSearchParams] = useState<string>("");

  useEffect(() => {
    handleDebouncedSearch(searchFunction, searchParams);
    // eslint-disable-next-line
  }, [searchParams]);

  return (
    <TextInput
      placeholder={placeholder}
      hasIcon
      iconSvg="search"
      className={`!rounded-[16px] !border !border-grey-200 !bg-transparent !p-3`}
      containerClassName={`!w-full ${className}`}
      value={searchParams}
      onChange={(e) => setSearchParams(e.target.value)}
      type={"text"}
      name={"searxh"}
      onBlur={() => {}}
    />
  );
};
